import React, { useState, useEffect, useRef } from 'react';

export function useVersionCheck(interval = 60000, onUpdate) {
  const currentHash = useRef(null);

  useEffect(() => {
    async function checkVersion() {
      try {
        const res = await fetch('/asset-manifest.json', { cache: 'no-store' });
        const manifest = await res.json();
        const mainJs = manifest.files && manifest.files['main.js'];
        if (!mainJs) return;
        if (currentHash.current && currentHash.current !== mainJs) {
          if (onUpdate) onUpdate();
        }
        currentHash.current = mainJs;
      } catch (e) {}
    }
    checkVersion();
    const id = setInterval(checkVersion, interval);
    return () => clearInterval(id);
  }, [interval, onUpdate]);
}

